import makeRequest from '../make-request'
import { ChatItem, ChatRoom, Metadata } from '../../types'

export const getChatMessages = async (sessionId: string | null, idToken: string) => {
    return await makeRequest<ChatItem[]>({
        url: `/api/sessions/${sessionId}/messages`,
        idToken,
    })
}

export const getChatRooms = async (userId: string | null, idToken: string) => {
    return await makeRequest<ChatRoom[]>({
        url: `/api/users/${userId}/sessions`,
        idToken,
    })
}

export const getFilters = async (idToken: string) => {
    return await makeRequest<Metadata>({
        url: `/api/metadata`,
        idToken,
    })
}
